import { servicesAuth } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import mapAuthResp from 'data-mappers/map-auth-resp';
import { auth, network } from 'types';
import onAuthSuccess from '../../../../../utils/on-auth-success';

const useSignInMutation = (
    arg0?: TAsyncStatesHandlers<
        network.TQueryDefWrapper<auth.TAuthResp>,
        string
    >,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<auth.TAuthResp>,
        string,
        auth.TSignInParams
    >({
        mutationFn: servicesAuth.signIn,
        mutationConfig: {
            onSuccess: (data) => {
                const mappedData = mapAuthResp(data);
                onAuthSuccess(mappedData);
            },
            onError: (data) => {},
        },
        asyncStateHandlers: arg0,
    });
};

export default useSignInMutation;
